import { schemaValidator } from '@tf/design-system-react';

export const schema = schemaValidator.object().shape({
  username: schemaValidator.string('Enter a email').required('Email is required'),
  password: schemaValidator.string('Enter a password').required('Password is required'),
});
